import svgUrl from "ni:svgr;Etl_QyxEP-csOp6EC9p7qf-4VyG-AYen7rTMBExgtiw";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const OutputMIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}><path fill="var(--tbl--colors--icons--output--secondary)" fillRule="evenodd" d="M5 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h5.708A8 8 0 0 1 18 8.252V5a3 3 0 0 0-3-3H5Z" clipRule="evenodd" /><path fill="var(--tbl--colors--icons--output--primary)" fillRule="evenodd" d="M16 24a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm-1-11a1 1 0 1 1 2 0v3.586l.293-.293a1 1 0 0 1 1.414 1.414l-2 2a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414l.293.293V13Z" clipRule="evenodd" /></svg>;
const Memo = memo(OutputMIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "OutputMIcon";
}